<router-outlet name="modal"></router-outlet>

<div class="row">
  <div class="col-12">
    @if (loading) {
      <wre-toolkit-loader></wre-toolkit-loader>
    } @else {
      @if (error) {
        <div class="p-3">Failed to retrieve the overview access users.</div>
      } @else {
        @if (accessMappings.length === 0) {
          <div class="col-12 text-start">
            <div class="fw-bold">No data to display.</div>
          </div>
        } @else {
          @if (safrOverviewListService.isNoSearchOrFilterResult) {
            <div class="no-results">
              No items were found based on your search criteria. Please try again.
            </div>
          } @else {
            @if (total > 0) {
              <div>
                <wre-safr-overview-access-table></wre-safr-overview-access-table>
                <div class="custom-pagination">
                  <wre-toolkit-pagination
                    [total$]="total$"
                    [(pageSize)]="safrOverviewListService.pageSize"
                    [(page)]="safrOverviewListService.page"
                    [isLoading]="loading">
                  </wre-toolkit-pagination>
                </div>
              </div>
            }
          }
        }
      }
    }
  </div>
</div>
